export class AccessToken {
  public Header: string;
  public Payload: string;
  public Signature: string;

  public constructor() {
    this.Header = '';
    this.Payload = '';
    this.Signature = '';
  }
}
